import React from 'react';
import PropTypes from 'prop-types';
// ...existing code...

// ...existing code...

export default class Cases extends React.PureComponent {
  static propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool
  }

  state = {
    data: this.props.data,
    cases: [],
    modal: null,
    visited: false
  };

  componentDidMount() {
    // Only process data if it's available
    if (this.state.data && this.state.data.length > 0) {
      this.processData();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if data prop has been updated and is now available
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data }, () => {
        if (this.state.data && this.state.data.length > 0) {
          this.processData();
        }
      });
    }
  }

  processData() {
    const data = this.state.data;
    if (!data || data.length === 0) return;

    const cases = data.filter(function(caseProject) {
      return caseProject.sys.contentType.sys.id === 'case';
    });

    cases.sort(function(a, b) {
      return (a.createdAt < b.createdAt) ? -1 : ((a.createdAt > b.createdAt) ? 1 : 0);
    });

    this.setState({cases: cases});
  }


  openModal(i) {
    if (this.state.modal === null) {
      this.setState({ modal: i });
    }
  }

  closeModals = () => {
    this.setState({ modal: null });
  }

  render() {
    const { cases, modal } = this.state;
    return (
      <div className="case-content">
        <div className="case-content-inner">
          <div className="case-wrap">
            <div className="case-wrap-inner">
              {cases.map((caseItem, i) => (
                <div className="case" key={i} onClick={() => this.openModal(i)}>
                  <div className="case-thumb" style={{ backgroundImage: `url(${caseItem.fields.photo.fields.file.url}?fm=jpg&q=80)` }}>
                    <h2 className="case-thumb-title">{caseItem.fields.title}</h2>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {cases.map(({ fields }, i) => (
          <div className="modal-wrap" key={i} style={{display: i === modal ? 'block' : 'none' }} >
            <div className="modal">
              <div className="modal-inner">
                <h2>{fields.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: fields.description }} />
                <img className="modal-image" alt={fields.title} src={fields.photo.fields.file.url + '?fm=jpg&q=80'} />
                <a className="close-modal" onClick={() => this.closeModals()}>&times;</a>
              </div>
            </div>
            <div className="modal-bg" onClick={() => this.closeModals()} />
          </div>
        ))}
      </div>
    );
  }
  }
